/**
 * RsvpSection -- 참석 여부 섹션 편집
 */

import { ClipboardCheck } from 'lucide-react'
import { useInvitationStore } from '../../../stores/invitationStore.js'
import { Toggle } from '../../ui/index.js'
import styles from './SectionForm.module.css'

export function RsvpSection() {
  const invitation = useInvitationStore((s) => s.invitation)
  const updateNested = useInvitationStore((s) => s.updateNested)
  if (!invitation) return null

  const rsvpFields = invitation.settings?.rsvpFields

  return (
    <div className={styles.form}>
      <div className={styles.personCard}>
        <div className={styles.personCardHeader}>
          <span className={styles.personCardIconBadge}>
            <ClipboardCheck size={20} />
          </span>
          <span className={styles.personCardLabel}>수집 항목</span>
        </div>
        <div className={styles.personCardDivider} />
        <div className={styles.personCardBody}>
          <Toggle
            label="연락처"
            checked={rsvpFields?.phone !== false}
            onChange={(v) => updateNested('settings.rsvpFields.phone', v)}
          />
          <Toggle
            label="참석 인원"
            checked={rsvpFields?.guestCount !== false}
            onChange={(v) => updateNested('settings.rsvpFields.guestCount', v)}
          />
          <Toggle
            label="식사 여부"
            checked={rsvpFields?.meal !== false}
            onChange={(v) => updateNested('settings.rsvpFields.meal', v)}
          />
        </div>
      </div>
    </div>
  )
}
